import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { OrgRoleListItemFragmentDoc } from '../../fragments/generated/OrgRoleListItem';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRolesNQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.OrgRolesFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type OrgRolesNQuery = { orgRoles: { totalCount: number, success: boolean, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, key?: string | null, userCount?: number | null, sampleUsers: Array<{ id: string, name?: string | null, profilePicture?: string | null }> } }> | null } };


export const OrgRolesNDocument = /*#__PURE__*/ gql`
    query orgRolesN($filters: OrgRolesFilters, $sort: [SortType!], $after: String, $first: Float) {
  orgRoles(filters: $filters, sort: $sort, after: $after, first: $first) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    edges {
      node {
        ...OrgRoleListItem
      }
    }
  }
}
    ${OrgRoleListItemFragmentDoc}`;

export function useOrgRolesNQuery(options?: Omit<Urql.UseQueryArgs<OrgRolesNQueryVariables>, 'query'>) {
  return Urql.useQuery<OrgRolesNQuery, OrgRolesNQueryVariables>({ query: OrgRolesNDocument, ...options });
};